import { STAGE } from '@/constants';
var log = require('log-util');

log.info('STAGE', STAGE);
const CognitoIdentityPoolId = {
  local: 'eu-west-1:5ceb74ee-008f-4b58-8cba-42b54f49c3e2',
  dev: 'eu-west-1:5ceb74ee-008f-4b58-8cba-42b54f49c3e2',
  cons: 'eu-west-1:ca7a4cb8-aad7-4e53-9ed4-bae852f8f75c',
  prod: 'eu-west-1:da5133f5-91b6-4234-81ef-03fccf61b79a'
};

const CognitoAccountId = {
  local: '806237468572',
  dev: '806237468572',
  cons: '806237468572',
  prod: '806237468572'
};

const graphQlEnpoints = {
  local: 'https://rcoy2z7cojfj5bntlbven7u3r4.appsync-api.eu-west-1.amazonaws.com/graphql',
  dev: 'https://rcoy2z7cojfj5bntlbven7u3r4.appsync-api.eu-west-1.amazonaws.com/graphql',
  cons: 'https://iw5b2rypgjgaheze7cz67v3blu.appsync-api.eu-west-1.amazonaws.com/graphql',
  prod: 'https://lr3q652gprf4jedmf42ypdsofe.appsync-api.eu-west-1.amazonaws.com/graphql'
};

const CognitoPoolId = {
  local: 'eu-west-1_F1XMA0y7S',
  dev: 'eu-west-1_F1XMA0y7S',
  cons: 'eu-west-1_2etzTXFzB',
  prod: 'eu-west-1_z8UolmO1H'
};

const CognitoClientId = {
  local: '3ha68gdoa2lfk9cpbeq6jaov56',
  dev: '570nj9bqhctahk2fvrlvaj378c',
  cons: '6upeppqsscti97mabe8d4reekf',
  prod: '2frl6u0t6ajbl07h96bjfd431h'
};

const CognitoLoginRedicrect = {
  local: 'http://localhost:8080/',
  dev: 'https://ppl-installation-dev.prysmiangroup.com/',
  cons: 'https://ppl-installation-cons.prysmiangroup.com/',
  prod: 'https://ppl-installation.prysmiangroup.com/'
};

const CognitoLogoutRedicrect = {
  local: 'http://localhost:8080/',
  dev: 'https://ppl-installation-dev.prysmiangroup.com/',
  cons: 'https://ppl-installation-cons.prysmiangroup.com/',
  prod: 'https://ppl-installation.prysmiangroup.com/'
};

const oauthDomain = {
  local: 'prysmian-dev.auth.eu-west-1.amazoncognito.com',
  dev: 'prysmian-dev.auth.eu-west-1.amazoncognito.com',
  cons: 'prysmian-cons.auth.eu-west-1.amazoncognito.com',
  prod: 'prysmian-prod.auth.eu-west-1.amazoncognito.com'
}

const providerBucket = {
  local: 'prysmian-provider-dev',
  dev: 'prysmian-provider-dev',
  cons: 'prysmian-provider-cons',
  prod: 'prysmian-provider-prod'
}

const operatorBucket = {
  local: 'prysmian-operator-dev',
  dev: 'prysmian-operator-dev',
  cons: 'prysmian-operator-cons',
  prod: 'prysmian-operator-prod'
}

const exchangeBucket = {
  local: 'prysmian-exchange-dev',
  dev: 'prysmian-exchange-dev',
  cons: 'prysmian-exchange-cons',
  prod: 'prysmian-exchange-prod'
}


const getValueByEnvironment = (valueSet, env) => valueSet[env];
const AWS_REGION = 'eu-west-1';
export default {
  aws_project_region: AWS_REGION,
  aws_appsync_graphqlEndpoint: getValueByEnvironment(graphQlEnpoints, STAGE),
  aws_appsync_region: AWS_REGION,
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  oauth: {
    domain: getValueByEnvironment(oauthDomain, STAGE),
    scope: [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin"
    ],
    redirectSignIn: getValueByEnvironment(CognitoLoginRedicrect, STAGE),
    redirectSignOut: getValueByEnvironment(CognitoLogoutRedicrect, STAGE),
    responseType: 'code',
  },
  Auth: {
    region: AWS_REGION,
    userPoolId: getValueByEnvironment(CognitoPoolId, STAGE),
    userPoolWebClientId: getValueByEnvironment(CognitoClientId, STAGE),
    authenticationFlowType: "USER_PASSWORD_AUTH"
  },
  provider_bucket: getValueByEnvironment(providerBucket, STAGE),
  operator_bucket: getValueByEnvironment(operatorBucket, STAGE),
  exchange_bucket: getValueByEnvironment(exchangeBucket, STAGE),
  cognito_identity_pool_id: getValueByEnvironment(CognitoIdentityPoolId, STAGE),
  cognito_account_id: getValueByEnvironment(CognitoAccountId, STAGE),
};
